import React, { Component } from "react";

class CustomCheckbox extends Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   is_checked: props.isChecked ? true : false
    // };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e) {
    // this.setState({ is_checked: !this.state.is_checked });
    // this.props.onChange(!this.props.isChecked,this.props.statekey)
    if (this.props.label.toLowerCase() === "management") {
      this.props.onValueChange(e.target.checked, this.props.statekey, this.props.eth);
    } else {
      this.props.onValueChange(e.target.checked, this.props.statekey);
    }
  }
  render() {
    const { checked, number, label, inline, hidden, ...rest } = this.props;
    const classes =
      inline !== undefined ? "checkbox checkbox-inline" : "checkbox";
    var style = {};
    if(hidden===true) {
      style.display = 'none';
    }
    return (
      <div style={style} className={classes}>
        <input
          id={number}
          type="checkbox"
          onChange={this.handleClick}
          checked={this.props.checked}
          {...rest}
        />
        <label htmlFor={number}>{label}</label>
      </div>
    );
  }
}

export default CustomCheckbox;
